import React, { useEffect, useState } from "react";
import { useSelector, useDispatch, useStore } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import { getNotificationId, getNotificationQueryId } from "../../utils/adminNotificationUtils";
import { getUsers } from "../../actions";
import Loader from "../../components/Loader";
import { adminCreateUser, adminConfirmCreatedUserEmail, adminResendCreatedUserEmail, searchUser, getUserById } from "../../actions/user.actions";
import { MainContainer } from "../MainContainer";
import RenderUsers from "./RenderUsers";
import RenderModalContent from "./RenderModalContent";
import PaginationComponent from "../../components/PaginationComponent";
import { setPageNumberUsers, setPageSizeUsers } from "../../reducers/user.reducer";
import CreateUserModal from "./CreateUserModal";

const Users = () => {
    const [params, setParams] = useSearchParams();
    const store = useStore();
    const notificationUserId = getNotificationQueryId(params.toString(), "notificationUserId");
    const [notificationUser, setNotificationUser] = useState(null);
    const [notificationError, setNotificationError] = useState(false);
    const [notificationReload, setNotificationReload] = useState(0);
    const [userDetailModal, setUserDetailModal] = useState(false);
    const [typeModal, setTypeModal] = useState("");
    const [currentId, setCurrentId] = useState(null);
    const [showCreate, setShowCreate] = useState(false);
    const currentAdmin = useSelector((state) => state.auth?.user || {});
    const isSuperAdmin = currentAdmin.role === "superAdmin";
    const { users, userDetails, loading, pageSize, pageNumber, totalAll, totalPages } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const handleCloseUserDetailsModal = () => {
        setUserDetailModal(false); setCurrentId(null); setTypeModal("");
        if (notificationUserId) {
            const next = new URLSearchParams(params);
            next.delete("notificationUserId");
            setParams(next, { replace: true });
        }
    };
    const showUserDetailsModal = (userId, typeM = "details") => { setTypeModal(typeM); setCurrentId(userId); setUserDetailModal(true); };

    useEffect(() => {
        if (!notificationUserId) return undefined;
        let active = true;
        setUserDetailModal(false);
        setNotificationError(false);
        Promise.resolve(dispatch(getUserById(notificationUserId))).then(() => {
            if (!active) return;
            const item = store.getState().user.userDetails;
            if (getNotificationId(item) !== notificationUserId) {
                setNotificationError(true);
                return;
            }
            setNotificationUser(item);
            setTypeModal("details");
            setCurrentId(notificationUserId);
            setUserDetailModal(true);
        }).catch(() => {
            if (active) setNotificationError(true);
        });
        return () => { active = false; };
    }, [dispatch, store, notificationUserId, notificationReload]);

    const activeUserDetails = notificationUserId && currentId === notificationUserId && getNotificationId(userDetails) !== notificationUserId
        ? notificationUser || userDetails : userDetails;

    return <MainContainer handleShow={isSuperAdmin ? () => setShowCreate(true) : undefined} buttonText={isSuperAdmin ? "Создать пользователя" : ""} noneCreateButton={!isSuperAdmin}
        typeSort="user" search={searchUser} get={getUsers} title="Все пользователи" noneSelectUpdatedPictures setPageNumber={setPageNumberUsers} setPageSize={setPageSizeUsers} pageNumber={pageNumber} pageSize={pageSize}>
        {notificationError && <div className="admin-notification-target" role="alert">
            <span>Не удалось загрузить пользователя из уведомления.</span>
            <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setNotificationReload((value) => value + 1)}>Повторить</button>
            <Link to="/users">Все пользователи</Link>
        </div>}
        {loading && !userDetailModal ? <Loader /> : null}
        <div style={{ display: loading && !userDetailModal ? "none" : "block" }}>
            <RenderUsers users={users} showUserDetailsModal={showUserDetailsModal} pageNumber={pageNumber} pageSize={pageSize} />
            <PaginationComponent dispatchAction totalAll={totalAll} pageSize={pageSize} setPageNumber={setPageNumberUsers} pageNumber={pageNumber} totalPages={totalPages} />
        </div>
        <RenderModalContent typeModal={typeModal} currentId={currentId} userDetails={activeUserDetails} setTypeModal={setTypeModal} userDetailModal={userDetailModal}
            handleCloseUserDetailsModal={handleCloseUserDetailsModal} isSuperAdmin={isSuperAdmin} currentAdmin={currentAdmin} />
        {isSuperAdmin ? <CreateUserModal show={showCreate} handleClose={() => setShowCreate(false)} onSubmit={(form) => dispatch(adminCreateUser(form))}
            onConfirm={({ userId, code }) => dispatch(adminConfirmCreatedUserEmail({ userId, code }))} onResend={(userId) => dispatch(adminResendCreatedUserEmail(userId))} /> : null}
    </MainContainer>;
};

export default Users;
